import { HeaderInfoService } from './../../../servicios/header-info.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagina-usuarios',
  templateUrl: './pagina-usuarios.component.html',
  styleUrls: ['./pagina-usuarios.component.scss']
})
export class PaginaUsuariosComponent implements OnInit {
  unidadId: number = 0;

  public displayedColumns: any[] = [
    {
      nombre: 'nombreUsuario',
      titulo: 'Nombre',
      valueFieldName: 'us_nombres'
    },
    {
      nombre: 'apellidoUsuario',
      titulo: 'Apellido',
      valueFieldName: 'us_apellidos'
    },
    {
      nombre: 'documento',
      titulo: 'No. de identidad',
      valueFieldName: 'us_numero_documento'
    },
    {
      nombre: 'correo',
      titulo: 'Correo',
      valueFieldName: 'us_correo'
    },
    {
      nombre: 'telefono',
      titulo: 'Teléfono',
      valueFieldName: 'us_celular'
    },
    {
      nombre: 'lugar',
      titulo: 'Lugar Asignado',
      valueFieldName: 'lugar_render'
    },
    {
      nombre: 'estadoEnvio',
      titulo: 'Estado Correo',
      valueFieldName: 'estado_legible'
    }
  ];

  constructor(
    private headerInfoService: HeaderInfoService
  ) {
    const dataString = localStorage.getItem('data_login');
    if (dataString) {
      try {
        const data_login = JSON.parse(dataString);
        this.unidadId = data_login?.company_id || 0;
      } catch (e) {
        this.unidadId = 0;
      }
    }
  }

  ngOnInit() {
    this.headerInfoService.cambiarTituloPagina("USUARIOS");
    this.headerInfoService.cambiarTituloTarjeta("¡Bienvenido a usuarios!");
    this.headerInfoService.cambiarTextoTarjeta("Aquí puedes visualizar y gestionar todos los usuarios registrados en el sistema.");
  }
}
